  import React, { useRef, useState, useEffect } from "react";

  const CarCultureSection = () => {
    const scrollContainerRef = useRef(null);
  const scrollBarRef = useRef(null);
  const dragOffsetRef = useRef(0);
    const [scrollState, setScrollState] = useState({
      progress: 0,
      thumbWidth: 100,
    });
    const [isDragging, setIsDragging] = useState(false);

    // Mobile Scroll Progress
    useEffect(() => {
      const container = scrollContainerRef.current;
      if (!container) return;

      const updateScrollProgress = () => {
        const { scrollLeft, scrollWidth, clientWidth } = container;
        if (scrollWidth <= clientWidth) {
          setScrollState({ progress: 0, thumbWidth: 100 });
          return;
        }
        const scrollableWidth = scrollWidth - clientWidth;
        const progress = (scrollLeft / scrollableWidth) * 100;
        const thumbWidth = (clientWidth / scrollWidth) * 100;
        setScrollState({
          progress: Math.min(100, Math.max(0, progress)),
          thumbWidth: Math.max(10, Math.min(100, thumbWidth)),
        });
      };

      container.addEventListener("scroll", updateScrollProgress);
      window.addEventListener("resize", updateScrollProgress);
      updateScrollProgress();
      return () => {
        container.removeEventListener("scroll", updateScrollProgress);
        window.removeEventListener("resize", updateScrollProgress);
      };
    }, []);

    const handleScrollBarClick = (e) => {
      if (e.target.classList.contains("scroll-indicator-thumb")) return;
      const container = scrollContainerRef.current;
      const scrollBar = scrollBarRef.current;
      if (!container || !scrollBar) return;

      const rect = scrollBar.getBoundingClientRect();
      const { scrollWidth, clientWidth } = container;
      const scrollableWidth = scrollWidth - clientWidth;
      if (scrollableWidth <= 0) return;

      const scrollBarWidth = rect.width;
      const thumbWidthPx = (clientWidth / scrollWidth) * scrollBarWidth;
      const usableWidth = Math.max(scrollBarWidth - thumbWidthPx, 1);
      const clickX = e.clientX - rect.left - thumbWidthPx / 2;
      const clampedX = Math.max(0, Math.min(usableWidth, clickX));
      const percentage = clampedX / usableWidth;

      container.scrollLeft = percentage * scrollableWidth;
    };

    const handleMouseDown = (e) => {
      e.preventDefault();
      const thumb = scrollBarRef.current?.querySelector(
        ".scroll-indicator-thumb"
      );
      const clientX = e.clientX ?? e.touches?.[0]?.clientX;
      if (thumb && clientX !== undefined) {
        const rect = thumb.getBoundingClientRect();
        dragOffsetRef.current = clientX - rect.left;
      } else {
        dragOffsetRef.current = 0;
      }
      setIsDragging(true);
    };

    useEffect(() => {
      if (!isDragging) return;
      const handleMouseMove = (e) => {
        e.preventDefault();
        const container = scrollContainerRef.current;
        const scrollBar = scrollBarRef.current;
        if (!container || !scrollBar) return;

        const rect = scrollBar.getBoundingClientRect();
        const clientX = e.clientX ?? e.touches?.[0]?.clientX;
        if (clientX === undefined) return;

        const { scrollWidth, clientWidth } = container;
        const scrollableWidth = scrollWidth - clientWidth;
        if (scrollableWidth <= 0) return;

        const scrollBarWidth = rect.width;
        const thumbWidthPx = (clientWidth / scrollWidth) * scrollBarWidth;
        const usableWidth = Math.max(scrollBarWidth - thumbWidthPx, 1);
        const offsetWithinBar =
          clientX - rect.left - (dragOffsetRef.current || thumbWidthPx / 2);
        const clampedX = Math.max(0, Math.min(usableWidth, offsetWithinBar));
        const percentage = clampedX / usableWidth;

        container.scrollLeft = percentage * scrollableWidth;
      };

      const handleMouseUp = () => {
        setIsDragging(false);
        dragOffsetRef.current = 0;
      };
      document.body.style.userSelect = "none";
      document.body.style.cursor = "grabbing";

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("touchmove", handleMouseMove, { passive: false });
      document.addEventListener("touchend", handleMouseUp);

      return () => {
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", handleMouseMove);
        document.removeEventListener("touchend", handleMouseUp);
      };
    }, [isDragging]);

    return (
      <>
        <style>{`
          .car-culture-scroll::-webkit-scrollbar { display: none; }
          .car-culture-scroll {
            -ms-overflow-style: none;
            scrollbar-width: none;
            scroll-behavior: smooth;
            overflow-y:    hidden;;
          }

          .car-culture-gt {
            top: 60%;
          }
@media (max-width: 767px) {
  .car-culture-scroll {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 1rem;
    
  }

  .car-culture-scroll::-webkit-scrollbar {
    display: none;
  }

  /* GT image scrolls with content */
  .car-culture-gt-container {
  position: absolute; /* inside scroll container, moves with it */
  top: 30%; /* vertically centered */
  left: 0; /* start at beginning of scroll container */
  transform: translateY(-50%);
  width: 1000px; /* 👈 fixed pixel width */
  height: 300px; /* 👈 fixed pixel height */
  z-index: 1;
  pointer-events: none;
  overflow: visible;
}

.car-culture-gt-mobile {
  width: 100%;
  height: 130%;
  object-fit: contain;
  display: block;
  opacity: 0.9;
}

  /* Each step scrolls with the GT path */
  .car-culture-step {
    position: relative;
    flex: 0 0 10%;
    min-width: %;
    max-width: 70%;
    scroll-snap-align: start;
    z-index: 10;
    margin-right: 1rem;
    padding-top: 2rem;
  }
    

  .car-culture-step-offset-range-2 {
    padding-top: 9rem;
    margin-left: 8rem;
  }

  .car-culture-step-offset-range-3 {
    padding-top: 4.5rem;
    margin-left: 4rem;
    margin-top: 12rem;
  }

  /* Fix spacing and readability */
  .car-culture-step h3 {
    font-size: clamp(0.85rem, 3.5vw, 1rem);
  }
   

  .car-culture-step p {
    font-size: clamp(0.78rem, 3vw, 0.93rem);
  }

  /* Scroll indicator */
  .scroll-indicator-line {
    margin-top: 1.5rem;

    
  }
}

@media (max-width: 500px) {
  .car-culture-step-offset-range-2 h3,
  .car-culture-step-offset-range-2 p {
    transform: translateX(2rem);
  }
}

          @media (min-width: 767px) and (max-width: 1023px) {
            .car-culture-scroll {
              flex-wrap: nowrap !important;
              overflow-x: hidden !important;
            }
            .car-culture-gt {
              top: 55% !important;
            }
           
            .car-culture-step:first-of-type {
              padding-left: 10rem !important;
             
           
              
            }
            .car-culture-step:first-of-type h3,
            .car-culture-step:first-of-type p {
            margin-top: 1.25rem !important;
              transform: translate(1.5rem, -1.25rem) !important;
            }
            .car-culture-step {
              flex: 0 0 45% !important;
              min-width: 4% !important;
              max-width: 27% !important;
              width: 4% !important;
              left: 1rem !important;
              top: 1rem !important;
              
            }
              .car-culture-step-offset-range-2 + span {
              width: 80px !important;
              font-size: 150px !important;
              top: 180px !important;
              left: auto !important;
              right: 1% !important;
          }
              @media (min-width: 767px) and (max-width: 1023px) {
 
             
            .car-culture-step-offset-range-2 {
              margin-top: 6rem !important;
              margin-left: 5rem !important;
            }
            .car-culture-step-offset-range-3 {
              margin-top: 2rem !important;
              margin-left: -1rem !important;
            }
            .car-culture-step-offset-range-3 h3,
            .car-culture-step-offset-range-3 p {
              transform: translateY(-1rem);
            }
              
          }
          @media (min-width: 1270px) and (max-width: 1586px) {
            .car-culture-scroll {
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: flex-start;
            }
            .car-culture-step {
              margin-top: 0 !important;
              margin-left: 0 !important;
              flex: 0 0 320px;
              max-width: 320px;
            }
            .car-culture-step--mid-offset-2 {
              margin-top: 8rem !important;
              margin-left: 11rem !important;
            }
            .car-culture-step--mid-offset-3 {
              margin-top: 13rem !important;
            }
        }
           
         
          @media (min-width: 1023px) and (max-width: 1123px) {
            .car-culture-step-offset-range-2 {
              margin-top: 4rem !important;
            }
            .car-culture-step-offset-range-3 {
              margin-top: 6rem !important;
                transform: translateY(-1rem);
            }
            .car-culture-step:first-of-type h3,
            .car-culture-step:first-of-type p {
              transform: translateY(1.5 rem);
            }
            .car-culture-gt {
              top: 55% !important;
            }
          }
            @media (min-width: 1123px) and (max-width: 1270px) {
              .car-culture-gt {
                top: 58% !important;
              }
              .car-culture-step-offset-range-2 {
                margin-top: 5rem !important;
              }
              .car-culture-step-offset-range-3 {
                margin-top: 4rem !important;
                transform: translateY(-1.5rem);
              }
            }
            @media (min-width: 1270px) and (max-width: 1606px) {
            .car-culture-gt {
              top:56% !important;
            }
              .car-culture-step-offset-range-2 {
                margin-top: 6rem !important;
                margin-left: 11rem !important;
              }
              .car-culture-step-offset-range-3 {
                margin-top: 6rem !important;
                transform: translateY(-1rem);
              }
            }
        `}</style>

        <section className="bg-[#0B0B0B] text-white py-12 sm:py-16 md:py-24 lg:py-16 xl:py-14 2xl:py-14 px-4 sm:px-8 md:px-12 lg:px-24 xl:px-24 2xl:px-24 relative overflow-hidden h-auto max-w-[1600px] mx-auto">
          {/* Heading */}
          <div className="text-center mb-16 sm:mb-20 md:mb-28 px-4 z-30 relative">
            <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-white uppercase tracking-wider font-noto-sans leading-tight mb-4" style={{ transform: 'scaleY(1.3)' }}>
              EXPERIENCE CAR CULTURE LIKE{" "}
              <span className="text-[#FF4D00]">NEVER BEFORE</span>
            </h2>
            <p className="text-gray-200 font-medium max-w-3xl mx-auto text-[clamp(0.85rem,1.2vw,1.05rem)] leading-relaxed">
              Car Hangout brings together every enthusiast's dream — showcase your
              ride, join events effortlessly, and connect with the community and
              trusted vendors, all in one app.
            </p>
          </div>

          {/* GT Path Background */}
          <div
            className="hidden md:block absolute left-1/2 top-[62%] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none z-10 car-culture-gt"
            style={{
              width: "clamp(1300px, 190vw, 2300px)",
              height: "clamp(480px, 70vh, 820px)",
              maxWidth: "100%",
            }}
          >
            <img
              src="/asset/gt.png"
              alt="Decorative car culture journey path illustration"
              className="w-full h-full object-contain opacity-90"
            />
          </div>

          {/* Steps */}
         <div
  ref={scrollContainerRef}
  className="relative z-20 flex flex-row md:flex-row md:flex-wrap justify-start md:justify-center items-start 
            gap-[clamp(2rem,4vw,6rem)] overflow-x-auto md:overflow-x-hidden overflow-y-hidden
             car-culture-scroll px-2 sm:px-4 md:px-6 pb-12 md:pb-0 w-full max-w-full"
>
  {/* GT Path for Mobile (scrolls with steps) */}
  <div
    className="car-culture-gt-container block md:hidden pointer-events-none"
  >
    <img
      src="/asset/gt.png"
      alt="Decorative car culture journey path illustration"
      className="car-culture-gt-mobile"
      loading="lazy"
    />
  </div>
 
            {/* Step 1 */}
            <div className="relative z-20 flex-shrink-0 w-[70%] sm:w-[55%] md:w-[25%] lg:w-[25%] xl:w-[23%] 2xl:w-[25%] max-w-[420px] min-w-[240px] xl:mt-16 md:mt-0 car-culture-step car-culture-step-offset-range-1">
              <h3 className="text-[clamp(1.1rem,1.7vw,1.35rem)] font-semibold mb-3">
                Showcase Your Ride
              </h3>
              <p className="text-gray-400 leading-relaxed text-[clamp(0.85rem,1vw,0.95rem)] xl:max-w-[340px] 2xl:max-w-[360px]">
                Share photos, videos, and updates about your car in a dedicated
                space where enthusiasts care. Build your profile, track your mods,
                and get inspired by rides from around the world.
              </p>
            
            </div>

            {/* Step 2 (moved more right) */}
            <div className="relative z-20 flex-shrink-0 w-[70%] sm:w-[50%] md:w-[30%] lg:w-[20%] xl:w-[25%] 2xl:w-[25%] max-w-[420px] min-w-[240px] mt-24 sm:mt-28 md:mt-[10rem] ml-16  md:ml-24 lg:ml-32 xl:ml-[13%] 2xl:ml-44 car-culture-step-offset-md transition-all duration-300 car-culture-step car-culture-step-offset-range-2" >
              <h3 className="text-[clamp(1.1rem,1.7vw,1.35rem)] font-semibold mb-3 md:mt-10">
                Discover & Join Events Easily
              </h3>
              <p className="text-gray-400 leading-relaxed text-[clamp(0.85rem,1vw,0.95rem)]">
                Find local car meets, plan shows, or boost your own events with
                our interactive map. Never miss an opportunity to connect with
                your community.
              </p>
            
            </div>
            

            {/* Step 3 */}
            <div className="relative z-20 flex-shrink-0 w-[70%] sm:w-[50%] md:w-[30%] lg:w-[20%] xl:w-[30%] 2xl:w-[25%] max-w-[420px] min-w-[240px] mt-32 sm:mt-40 md:mt-[14rem] car-culture-step-offset-md car-culture-step car-culture-step-offset-range-3">
              <h3 className="text-[clamp(1.1rem,1.7vw,1.35rem)] font-semibold mb-3 md:mt-28">
                Connect with Vendors & Compete
              </h3>
              <p className="text-gray-400 leading-relaxed text-[clamp(0.85rem,1vw,0.95rem)]">
                Access trusted vendors with exclusive discounts, and participate
                in exciting challenges like "Challenge My Ride" to prove your
                build and gain recognition.
              </p>
            </div>
          
          </div>

          {/* Scroll Indicator (mobile only) */}
          <div className="relative z-30 flex justify-center w-full -mt-2 mb-10 md:hidden">
            <div
              ref={scrollBarRef}
              onClick={handleScrollBarClick}
              className="scroll-indicator-line w-[40%] h-1 bg-gray-800 rounded-full relative"
            >
              <div
                onMouseDown={handleMouseDown}
                onTouchStart={handleMouseDown}
                className="scroll-indicator-thumb absolute top-0 left-0 h-1 bg-[#FF4D00] rounded-full transition-all duration-200"
                style={{
                  width: "18%",
                  transform: `translateX(${scrollState.progress * 450 / 100}%)`,
                  transition: isDragging ? "none" : "all 0.2s ease",
                }}
              />
            </div>
          </div>
        </section>
      </>
    );
  };

  export default CarCultureSection;
